import {Action} from '@ngrx/store';

export const REFRESH_STATE = '[Refresh] refresh';
export const RESET_STATE = '[Refresh] reset';

export class RefreshState implements Action {
  readonly type = REFRESH_STATE;
  constructor(public payload: boolean) {}
}
export class ResetState implements Action {
  readonly type = RESET_STATE;
  constructor(public payload: boolean = false) {}
}

export type Actions = RefreshState | ResetState;
